import 'intersection-observer'
import * as React from "react"
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types.ext.gen"
import { InnerHtmlWrapper } from "../../../../utils/InnerHtmlWrapper"

export type timelineBlockProps = {
  blockIndex: number
  title: string
  introduction: string
  items: Immutable.List<timelineItem>
}

export type timelineItem = {
  title: string
  introduction: string
  media: ParsedMediaImage
}

export type timelineBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function timelineBlock(
  props: timelineBlockProps,
  options?: { style: timelineBlockStyle; key?: string }
): (s:CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> {
    return (s: CMSState) => (public_state:PublicSiteState) =>
    fromJSX(() => {
        return (
          <section className="block block--timeline ls-block-spacing">
            <div className="block__inner ls-container">
            {(props.title || props.introduction) ? (
              <header className="block__header">
                {props.title && <h2 className="block__title title--l">{props.title}</h2>}
                  {props.introduction &&
                    // <div className="block__intro" dangerouslySetInnerHTML={{__html: props.introduction}} />
                    <InnerHtmlWrapper className="block__intro" text={props.introduction} />
                  }
              </header>
              )
              : <></>
            }

              <div className="block__content">
                <ul className="block__list">
                  {props.items.map(item => <>
                    <li className="block__item item"> 
                    {/* TO DO: add class if block has image on left or right " item--left" */}
                      <div className="item__inner">
                        <div className="item__content">
                          <header className="item__header">
                            <h3 className="item__title title--m">{item.title}</h3>
                          </header>
                          <div className="item__text">
                            <div className="item__intro">{item.introduction}</div>
                          </div>
                        </div>
                        <div className="item__visual">
                          <img
                            loading="lazy"
                            className="item__image"
                            src={item.media.field_media_image.image.url} 
                            alt={item.media.field_media_image.alt}
                          />
                        </div>
                      </div>
                    </li>
                    </>
                  ).toArray()}
                </ul>
              </div>
            </div>
          </section>
        )
    })
}